export enum EPosition {
    Top = 'Top',
    Right = 'Right',
    Bottom = 'Bottom',    
    Left = 'Left'
}